import { Col, Container, Row } from 'react-bootstrap'
import React from 'react'
import { Zoom } from 'react-awesome-reveal'
import Ground_1 from '../../assets/images/home_ground_1.jpg'
import Ground_2 from '../../assets/images/home_ground_2.jpg'
import Ground_3 from '../../assets/images/home_ground_3.jpg'

const GallerySection = () => {
    return (
        <section className="gallery-section bg-white px-4 px-md-0 pb-2 pb-md-3">
            <Container className="py-4">
                <Row
                    sm={12}
                    className="justify-content-center text-center mb-3"
                >
                    <Col sm={12}>
                        <h2 className="section-title">
                            Made From The
                            <br /> Ground Up
                        </h2>
                    </Col>
                </Row>
                <Row className="gallery-photos pt-4 pb-3">
                    <Col xs={3} className="px-1 px-sm-2 px-md-3 ps-0">
                        <Zoom triggerOnce={true}>
                            <div className="h-line mx-auto ms-0"></div>
                            <div className="window">
                                <img
                                    src={Ground_1}
                                    alt="gallery"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </Zoom>
                    </Col>

                    <Col xs={6} className="px-1 px-sm-2 px-md-3">
                        <Zoom triggerOnce={true}>
                            <div className="window">
                                <img
                                    src={Ground_2}
                                    alt="gallery"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                            <div className="h-line mx-auto"></div>
                        </Zoom>
                    </Col>

                    <Col xs={3} className="px-1 px-sm-2 px-md-3 pe-0">
                        <Zoom triggerOnce={true}>
                            <div className="h-line mx-auto me-0"></div>
                            <div className="window">
                                <img
                                    src={Ground_3}
                                    alt="gallery"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </Zoom>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default GallerySection
